const EN = {
  'outlander-2025.interior.image-1.hotspot-1.label': 'Steering & Dashboard',
  'outlander-2025.interior.image-1.hotspot-1.message': 'Steering and dashboard',
  'outlander-2025.interior.image-1.hotspot-2.label': 'Climate Control',
  'outlander-2025.interior.image-1.hotspot-2.message': 'Climate control',
  'outlander-2025.interior.image-1.hotspot-3.label': 'Gearshift &\nCenter Console',
  'outlander-2025.interior.image-1.hotspot-3.message': 'Gearshift and center console',
  'outlander-2025.interior.image-1.hotspot-4.label': "Driver's seat",
  'outlander-2025.interior.image-1.hotspot-4.message': "Driver's seat",

  'outlander-2025.interior.image-2.hotspot-1.label': '3rd-Row Fold-Flat Seats',
  'outlander-2025.interior.image-2.hotspot-1.message': '3rd-row fold-flat seats',
  'outlander-2025.interior.image-2.hotspot-2.label': 'Seatbelts & Restraints',
  'outlander-2025.interior.image-2.hotspot-2.message': 'Seatbelts and restraints',
  'outlander-2025.interior.image-2.hotspot-3.label': 'Active Safety Features',
  'outlander-2025.interior.image-2.hotspot-3.message': 'Active safety features',
  'outlander-2025.interior.image-2.hotspot-4.label': '2nd-Row Amenities',
  'outlander-2025.interior.image-2.hotspot-4.message': '2nd-row amenities',

  'outlander-2025.exterior.hotspot-1.label': 'Front Grille & Lighting',
  'outlander-2025.exterior.hotspot-1.message': 'Front grille and lighting',
  'outlander-2025.exterior.hotspot-2.label': 'Roof Features',
  'outlander-2025.exterior.hotspot-2.message': 'Roof features',
  'outlander-2025.exterior.hotspot-3.label': 'Entry & Starting System',
  'outlander-2025.exterior.hotspot-3.message': 'Entry and starting system',
  'outlander-2025.exterior.hotspot-4.label': 'Wheels & Tires',
  'outlander-2025.exterior.hotspot-4.message': 'Wheels and tires',
  'outlander-2025.exterior.hotspot-5.label': 'Rear Features',
  'outlander-2025.exterior.hotspot-5.message': 'Rear features',
  'outlander-2025.exterior.hotspot-6.label': 'Bumper & Skid Plate',
  'outlander-2025.exterior.hotspot-6.message': 'Bumper and skid plate',
  'outlander-2025.exterior.hotspot-7.label': 'Liftgate & Fuel Filler',
  'outlander-2025.exterior.hotspot-7.message': 'Liftgate and fuel filler',
  'outlander-2025.exterior.hotspot-8.label': 'Side Mirrors & Door Handles',
  'outlander-2025.exterior.hotspot-8.message': 'Side mirrors and door handles',
  'outlander-2025.exterior.hotspot-9.label': 'Windows & Wipers',
  'outlander-2025.exterior.hotspot-9.message': 'Windows and wipers',

  'tourController.interior': 'Interior',
  'tourController.exterior': 'Exterior',

  'outlander-2025.blueprint.safety.tab-1': 'Curtains and seats',
  'outlander-2025.blueprint.safety.tab-2': 'Front-row knee SRS airbag',
  'outlander-2025.blueprint.safety.hotspot-1.label': 'Side curtain airbag',
  'outlander-2025.blueprint.safety.hotspot-1.message': 'Side curtain airbag',
  'outlander-2025.blueprint.safety.hotspot-2.label': 'Seat mounted\nside airbag',
  'outlander-2025.blueprint.safety.hotspot-2.message': 'Seat mounted airbag',
  'outlander-2025.blueprint.safety.hotspot-3.label': 'Front seat-mounted\ncenter airbag',
  'outlander-2025.blueprint.safety.hotspot-3.message': 'Front seat-mounted center airbag',
  'outlander-2025.blueprint.safety.hotspot-4.label': 'Driver seat',
  'outlander-2025.blueprint.safety.hotspot-4.message': 'Driver seat',
  'outlander-2025.blueprint.safety.hotspot-5.label': 'Front passenger seat',
  'outlander-2025.blueprint.safety.hotspot-5.message': 'Front passenger seat',

  'outlander-2025.launcher.introduction': 'Click to ask anything about the 2025 Outlander',
}

export default EN
